import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CUSTOMER,
  SOFTLINE_API_CUSTOMER_CARDS,
  SOFTLINE_API_CUSTOMER_COLLECTORS,
  SOFTLINE_API_CUSTOMER_CONDITIONS_SHEET,
  SOFTLINE_API_CUSTOMER_CONTACTS,
  SOFTLINE_API_CUSTOMER_FUEL_CARDS,
  SOFTLINE_API_CUSTOMER_MAIN_CONTACT,
  SOFTLINE_API_CUSTOMER_NOTES,
  SOFTLINE_API_CUSTOMER_SCAN,
} from '../customer-info.api';
import { CustomerCard, CustomerFuelCard } from '../types/card';
import { CustomerCollector } from '../types/collector';
import { CustomerConditionSheetEntry } from '../types/condition-sheet';
import { CustomerContact } from '../types/contact';
import { CustomerResponse } from '../types/customer';
import { CustomerNote } from '../types/note';

@Injectable({ providedIn: 'root' })
export class CustomerRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  getById(id: string): Promise<CustomerResponse> {
    return this.dataAccess.get<CustomerResponse>({
      path: SOFTLINE_API_CUSTOMER,
      pathParams: { id },
    });
  }

  getNotes(id: string): Promise<CustomerNote[]> {
    return this.dataAccess.get<CustomerNote[]>({
      path: SOFTLINE_API_CUSTOMER_NOTES,
      pathParams: { id },
    });
  }

  getMainContact(id: string): Promise<CustomerContact> {
    return this.dataAccess.get<CustomerContact>({
      path: SOFTLINE_API_CUSTOMER_MAIN_CONTACT,
      pathParams: { id },
    });
  }

  getContacts(id: string): Promise<CustomerContact[]> {
    return this.dataAccess.get<CustomerContact[]>({
      path: SOFTLINE_API_CUSTOMER_CONTACTS,
      pathParams: { id },
    });
  }

  getCollectors(id: string): Promise<CustomerCollector[]> {
    return this.dataAccess.get<CustomerCollector[]>({
      path: SOFTLINE_API_CUSTOMER_COLLECTORS,
      pathParams: { id },
    });
  }

  getCards(id: string): Promise<CustomerCard[]> {
    return this.dataAccess.get<CustomerCard[]>({
      path: SOFTLINE_API_CUSTOMER_CARDS,
      pathParams: { id },
    });
  }

  getFuelCards(id: string): Promise<CustomerFuelCard[]> {
    return this.dataAccess.get<CustomerFuelCard[]>({
      path: SOFTLINE_API_CUSTOMER_FUEL_CARDS,
      pathParams: { id },
    });
  }

  getConditionsSheets(id: string): Promise<CustomerConditionSheetEntry[]> {
    return this.dataAccess.get<CustomerConditionSheetEntry[]>({
      path: SOFTLINE_API_CUSTOMER_CONDITIONS_SHEET,
      pathParams: { id },
    });
  }

  getByBarcode(type: string, code: string): Promise<CustomerResponse> {
    return this.dataAccess.get<CustomerResponse>({
      path: SOFTLINE_API_CUSTOMER_SCAN,
      pathParams: { type, code },
    });
  }
}
